import { styled } from '../../styled-components';

export const UiColorRed = styled.div.attrs({ className: 'UiColorRed' })`
  color: #cf1e2f;
`;
